/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ quality: NonNullable<unknown> }} Mesh_Path_QualityInputs */



/**
* | output |
* | --- |
* | "Quality {quality}" |
*
* @param {Mesh_Path_QualityInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const mesh_path_quality = /** @type {((inputs: Mesh_Path_QualityInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesh_Path_QualityInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Quality ${i?.quality}`)
	return /** @type {LocalizedString} */ (`Qualité ${i?.quality}`)
});